<template>
  <div class="Productcenter">
    <div class="pagestitle clearfix">
      <span class="pageslink">
          <li><router-link class="indexicon" to="/" /></li>
          <li><router-link to="/honor1">资质证书</router-link> > </li><li><router-link class='cur' :to="cur">{{curName}}</router-link></li>
      </span>
      <h4>
        <span>{{curName}}</span>
<!--        <img class="titleimg" :src="baseApi + 'webimages/' +curImage+ '.png'" >-->
      </h4>
    </div>
    <div class="insidesnav clearfix">
      <router-link :class="cur === '/honor1' ? 'cur': ''" to="/honor1">企业资质</router-link>
      <router-link :class="cur === '/honor2' ? 'cur': ''" to="/honor2">企业证书</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cur: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  computed: {
    curName () {
      switch (this.cur) {
        case '/honor1':
          return '企业资质'
        case '/honor2':
          return '企业证书'
        default:
          return ''
      }
    },
    curImage () {
      switch (this.cur) {
        case '/honor1':
          return 'zzry'
        case '/honor2':
          return 'zzry'
        default:
          return ''
      }
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/honor/componets/Tab.vue